// Major world cities with lat/lon and standard UTC offset (hours).
// Used by the "Cast Your Chart" picker so charts compute against real coordinates
// without an external geocoding service. DST is not modelled (astrological approx.).

export const CITIES = [
  { name: "Lagos, Nigeria", lat: 6.5244, lon: 3.3792, tz: 1 },
  { name: "Accra, Ghana", lat: 5.6037, lon: -0.187, tz: 0 },
  { name: "Nairobi, Kenya", lat: -1.2921, lon: 36.8219, tz: 3 },
  { name: "Cairo, Egypt", lat: 30.0444, lon: 31.2357, tz: 2 },
  { name: "Johannesburg, South Africa", lat: -26.2041, lon: 28.0473, tz: 2 },
  { name: "Addis Ababa, Ethiopia", lat: 9.03, lon: 38.74, tz: 3 },
  { name: "Kingston, Jamaica", lat: 17.9714, lon: -76.7929, tz: -5 },
  { name: "Port-au-Prince, Haiti", lat: 18.5944, lon: -72.3074, tz: -5 },
  { name: "New Orleans, USA", lat: 29.9511, lon: -90.0715, tz: -6 },
  { name: "New York, USA", lat: 40.7128, lon: -74.006, tz: -5 },
  { name: "Atlanta, USA", lat: 33.749, lon: -84.388, tz: -5 },
  { name: "Chicago, USA", lat: 41.8781, lon: -87.6298, tz: -6 },
  { name: "Los Angeles, USA", lat: 34.0522, lon: -118.2437, tz: -8 },
  { name: "Houston, USA", lat: 29.7604, lon: -95.3698, tz: -6 },
  { name: "Toronto, Canada", lat: 43.6532, lon: -79.3832, tz: -5 },
  { name: "Mexico City, Mexico", lat: 19.4326, lon: -99.1332, tz: -6 },
  { name: "Salvador, Brazil", lat: -12.9777, lon: -38.5016, tz: -3 },
  { name: "São Paulo, Brazil", lat: -23.5505, lon: -46.6333, tz: -3 },
  { name: "Bogotá, Colombia", lat: 4.711, lon: -74.0721, tz: -5 },
  { name: "Buenos Aires, Argentina", lat: -34.6037, lon: -58.3816, tz: -3 },
  { name: "London, UK", lat: 51.5074, lon: -0.1278, tz: 0 },
  { name: "Paris, France", lat: 48.8566, lon: 2.3522, tz: 1 },
  { name: "Madrid, Spain", lat: 40.4168, lon: -3.7038, tz: 1 },
  { name: "Lisbon, Portugal", lat: 38.7223, lon: -9.1393, tz: 0 },
  { name: "Rome, Italy", lat: 41.9028, lon: 12.4964, tz: 1 },
  { name: "Athens, Greece", lat: 37.9838, lon: 23.7275, tz: 2 },
  { name: "Berlin, Germany", lat: 52.52, lon: 13.405, tz: 1 },
  { name: "Amsterdam, Netherlands", lat: 52.3676, lon: 4.9041, tz: 1 },
  { name: "Istanbul, Turkey", lat: 41.0082, lon: 28.9784, tz: 3 },
  { name: "Moscow, Russia", lat: 55.7558, lon: 37.6173, tz: 3 },
  { name: "Dubai, UAE", lat: 25.2048, lon: 55.2708, tz: 4 },
  { name: "Tehran, Iran", lat: 35.6892, lon: 51.389, tz: 3.5 },
  { name: "Mumbai, India", lat: 19.076, lon: 72.8777, tz: 5.5 },
  { name: "Delhi, India", lat: 28.6139, lon: 77.209, tz: 5.5 },
  { name: "Chennai, India", lat: 13.0827, lon: 80.2707, tz: 5.5 },
  { name: "Kolkata, India", lat: 22.5726, lon: 88.3639, tz: 5.5 },
  { name: "Colombo, Sri Lanka", lat: 6.9271, lon: 79.8612, tz: 5.5 },
  { name: "Dhaka, Bangladesh", lat: 23.8103, lon: 90.4125, tz: 6 },
  { name: "Bangkok, Thailand", lat: 13.7563, lon: 100.5018, tz: 7 },
  { name: "Jakarta, Indonesia", lat: -6.2088, lon: 106.8456, tz: 7 },
  { name: "Singapore", lat: 1.3521, lon: 103.8198, tz: 8 },
  { name: "Kuala Lumpur, Malaysia", lat: 3.139, lon: 101.6869, tz: 8 },
  { name: "Manila, Philippines", lat: 14.5995, lon: 120.9842, tz: 8 },
  { name: "Hong Kong", lat: 22.3193, lon: 114.1694, tz: 8 },
  { name: "Beijing, China", lat: 39.9042, lon: 116.4074, tz: 8 },
  { name: "Shanghai, China", lat: 31.2304, lon: 121.4737, tz: 8 },
  { name: "Tokyo, Japan", lat: 35.6762, lon: 139.6503, tz: 9 },
  { name: "Seoul, South Korea", lat: 37.5665, lon: 126.978, tz: 9 },
  { name: "Port Moresby, PNG", lat: -9.4438, lon: 147.1803, tz: 10 },
  { name: "Suva, Fiji", lat: -18.1248, lon: 178.4501, tz: 12 },
  { name: "Honiara, Solomon Islands", lat: -9.4456, lon: 159.9729, tz: 11 },
  { name: "Sydney, Australia", lat: -33.8688, lon: 151.2093, tz: 10 },
  { name: "Melbourne, Australia", lat: -37.8136, lon: 144.9631, tz: 10 },
  { name: "Darwin, Australia", lat: -12.4634, lon: 130.8456, tz: 9.5 },
  { name: "Perth, Australia", lat: -31.9505, lon: 115.8605, tz: 8 },
  { name: "Auckland, New Zealand", lat: -36.8485, lon: 174.7633, tz: 12 },
];
